var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app_detail_tab4"
  }, [_c('h1', [_vm._v($t("cf8e224", "应用自检"))]), _c('p', [_vm._v($t("4qerpnf", "检测应用服务器API 接入情况"))]), _c('Button', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.check
    }
  }, [_vm._v($t("cd0t5i4", "开始检测"))]), _vm.showTip ? _c('div', {
    class: _vm.success ? 'success' : 'fail',
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('Icon', {
    class: _vm.success ? 'success' : 'fail',
    attrs: {
      "type": _vm.success ? 'ios-checkmark-circle' : 'ios-close-circle',
      "size": "18"
    }
  }), _vm._v("API " + _vm._s(_vm.success ? $t("e94073", "已接通") : $t("flpz33", "未接通")) + " ")], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };